import { ClaimRequestRepository } from '../../domain/repositories/ClaimRequestRepository';

export class AssignNextPreventionClaimWithNewDocumentation {
    private claimRequestRepository: ClaimRequestRepository;

    constructor(claimRequestRepository: ClaimRequestRepository) {
        this.claimRequestRepository = claimRequestRepository;
    }

    async execute(countryCode?: string): Promise<string> {
        return this.claimRequestRepository.assignNextPreventionClaimWithNewDocumentation(countryCode);
    }
}
